import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LoadingSpinner } from "atoms";
import { AuthProvider } from "features/auth";
import { I18nProvider } from "./i18n";
import { QueryProvider } from "./query";
import { ThemeProvider } from "./theme";
import { WalletProvider } from "./wallet";

interface AppProvidersProps {
  children: React.ReactNode;
}

function AppProviders({ children }: AppProvidersProps) {
  return (
    <BrowserRouter>
      <HelmetProvider>
        <QueryProvider>
          <WalletProvider>
            <AuthProvider>
              <I18nProvider>
                <ThemeProvider>
                  <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>
                </ThemeProvider>
              </I18nProvider>
            </AuthProvider>
          </WalletProvider>
        </QueryProvider>
      </HelmetProvider>
    </BrowserRouter>
  );
}

export { AppProviders };
